const theme = {
  red: "#fd1738",
}

export default theme
